export const appName = process.env.REACT_APP_WEB_NAME || "DEMO";
export const rightSideConfig = {
  "/": "LobbyMenu",
  "/slots": "PlatformRight",
  "/live-casino": "PlatformRight",
  "/fish": "PlatformRight",
  "/arcade": "PlatformRight",
  "/block-chain": "PlatformRight",
  "/lottery": "PlatformRight",
  "/sports": "PlatformRight",
  "/bingo": "PlatformRight",
};
